import practiceReport from './practice-report'

const exam = {
  path: 'exam',
  component: resolve => require(['../../../../pages/portal/sbs/exam'], resolve),
  redirect: 'exam/practice_report',
  children: [
    practiceReport
  ]
}

export default exam
